import { createClient } from '@supabase/supabase-js';

// Try both import.meta.env and process.env (for Vite config define)
const url = import.meta.env.VITE_SUPABASE_URL || (process.env as any)?.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY ||
            (process.env as any)?.VITE_SUPABASE_KEY || (process.env as any)?.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error('❌ Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (or VITE_SUPABASE_KEY) in your environment.');
}

export const supabase = createClient(url, key);
